module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"description":"All related boards will also be archived.","no":"@:labels.no","question":"Are you sure you want to archive this flow ?","title":"Archive Flow","yes":"@:labels.yes"},"fr":{"description":"Tous les tableaux associés seront aussi archivés.","no":"@:labels.no","question":"Êtes-vous certain de vouloir archiver ce flux ?","title":"Archiver le flux","yes":"@:labels.yes"}}')
  delete Component.options._Ctor
}
